import { DataGrid, GridColDef, GridRowData } from '@material-ui/data-grid';
import React from 'react';
import Alert from '../../components/Alert';
import Modal from '../../components/Modal';
import Container from "../../components/Container";
import { Dashboard } from '../../interfaces';
import { api } from '../../services/api';
import { UserContext } from '../../UserContext';
import InfoIcon from '@material-ui/icons/Info';

const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'sDescricao', headerName: 'Descrição Dashbord BI', flex: 1 },
    { field: 'sObservacao', headerName: 'Icone de Informação', flex: 1, hide: true},
    { field: 'sLink', headerName: 'Link', flex: 1, hide: true},
    { field: 'Icon', headerName: 'Opções', flex: 1,
    renderCell: (params) => {
        return (
            <div className="d-flex justify-content-between align-items-center" style={{cursor: "pointer"}}>
                <InfoIcon fontSize="large"/>
            </div>
        );
    }}
];

const DashboardBI: React.FC = () => {
    document.title = "Dashboard BI - Sultan Veste a Casa";

    const [dataDashboard, setData] = React.useState<GridRowData[]>([]);
    const [error, setError] = React.useState("");
    const [success, setSuccess] = React.useState("");
    const [info, setInfo] = React.useState(false);
    const [observacao, setObservacao] = React.useState("");

    const {setLoading} = React.useContext(UserContext);

    React.useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = async () => {
        try{
            setLoading(true);

            const {data} = await api.get('/dashboard');

            const rows = data.infos.map((el: Dashboard) => { 
                return {
                    id: el.PK, 
                    sDescricao: el.sDescricao, 
                    sObservacao: el.sObservacao,
                    sLink: el.sLink
                }
            });

            setData(rows);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    const handleMessageError = () => {
        setError('');
    }

    const handleOpen = (sLink: string) => {
        window.open(
            sLink,
            '_blank'
        );
    }

    const handleCloseInfo = () => {
        setInfo(false);
    }

    return(
        <Container>
            <div style={{ height: 400, width: '100%', background: '#fff' }}>
                <DataGrid
                    rows={dataDashboard}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    onCellClick={(el) => {
                            if(el.field === 'sDescricao'){
                                const link = el.getValue(el.id, 'sLink')
                                handleOpen(`${link}`);
                            }else if(el.field === 'Icon'){
                                const observacaoText = el.getValue(el.id, 'sObservacao')
                                setObservacao(`${observacaoText}`);
                                setInfo(true);
                            }
                        }
                    }
                />
            </div>

            <Modal
                open={info} 
                onClose={handleCloseInfo} 
                titleModal={"Informações"}
                message={observacao}
                textConfirm={"OK"}
            />

            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                    
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>
        </Container>
    );
}

export default DashboardBI;